// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueHead from 'vue-head'
import { i18n } from '@/plugins/i18n'
import { Trans } from './plugins/Translation'
var VueScrollTo = require('vue-scrollto')

Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)

Vue.config.productionTip = false

if (window.innerWidth <= 767) {
  Vue.use(VueScrollTo, {
    duration: 700,
    easing: 'ease',
    offset: -62
  })
} else {
  Vue.use(VueScrollTo, {
    duration: 700,
    easing: 'ease',
    offset: -90
  })
}

Vue.use(VueHead)

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  i18n,
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js